export default __webpack_public_path__ + "static/media/gtd.fb003638.jpg";